import React, { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { IconUsers } from '../components/Icons';

const TenantScreeningView = () => {
  const { t } = useLanguage();
  
  const [applications] = useState([
    {
      id: 1,
      applicantName: 'John Smith',
      nationality: 'American',
      appliedProperty: 'Makati Condo Unit 301',
      status: 'reviewing',
      applicationDate: '2024-01-15',
    },
    {
      id: 2,
      applicantName: 'Wang Wei',
      nationality: 'Chinese',
      appliedProperty: 'BGC Apartment 201',
      status: 'approved',
      applicationDate: '2024-01-12',
    },
    {
      id: 3,
      applicantName: 'Kim Min-jun',
      nationality: 'Korean',
      appliedProperty: 'Ortigas Condo 505',
      status: 'reviewing',
      applicationDate: '2024-01-14',
    },
    {
      id: 4,
      applicantName: 'Takeshi Yamamoto',
      nationality: 'Japanese',
      appliedProperty: 'Alabang House 102',
      status: 'approved',
      applicationDate: '2024-01-11',
    },
    {
      id: 5,
      applicantName: 'Raj Patel',
      nationality: 'Indian',
      appliedProperty: 'Quezon City Townhouse 203',
      status: 'rejected',
      applicationDate: '2024-01-10',
    },
    {
      id: 6,
      applicantName: 'Maria Dela Cruz',
      nationality: 'Filipino',
      appliedProperty: 'Pasig Apartment 408',
      status: 'reviewing',
      applicationDate: '2024-01-16',
    },
  ]);

  const getStatusColor = (status) => {
    switch (status) {
      case 'reviewing':
        return 'bg-yellow-100 text-yellow-800';
      case 'approved':
        return 'bg-green-100 text-green-800';
      case 'rejected':
        return 'bg-red-100 text-red-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 'reviewing':
        return t('reviewing');
      case 'approved':
        return t('approved');
      case 'rejected':
        return t('rejected');
      default:
        return status;
    }
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <h1 className="text-3xl font-bold text-gray-900 mb-8">{t('tenantScreening')}</h1>

      <div className="bg-white rounded-lg shadow-md p-6">
        <h2 className="text-xl font-semibold mb-4 flex items-center">
          <IconUsers className="w-6 h-6 mr-2" />
          {t('newApplications')}
        </h2>

        {/* Desktop View */}
        <div className="hidden md:block">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  {t('applicant')}
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  {t('appliedProperty')}
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  {t('status')}
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  {t('actions')}
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {applications.map((application) => (
                <tr key={application.id}>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="text-sm font-medium text-gray-900">
                      {application.applicantName}
                    </div>
                    <div className="text-sm text-gray-500">
                      {application.nationality} · {application.applicationDate}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="text-sm text-gray-900">{application.appliedProperty}</div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${getStatusColor(application.status)}`}>
                      {getStatusText(application.status)}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                    <button className="text-blue-600 hover:text-blue-900 mr-3">
                      {t('viewDetails')}
                    </button>
                    {application.status === 'reviewing' && (
                      <>
                        <button className="text-green-600 hover:text-green-900 mr-3">
                          {t('approve')}
                        </button>
                        <button className="text-red-600 hover:text-red-900">
                          {t('reject')}
                        </button>
                      </>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Mobile View */}
        <div className="md:hidden space-y-4">
          {applications.map((application) => (
            <div key={application.id} className="border border-gray-200 rounded-lg p-4">
              <div className="flex justify-between items-start mb-2">
                <div>
                  <h3 className="text-sm font-medium text-gray-900">
                    {application.applicantName}
                  </h3>
                  <p className="text-xs text-gray-500">{application.nationality} · {application.applicationDate}</p>
                </div>
                <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${getStatusColor(application.status)}`}>
                  {getStatusText(application.status)}
                </span>
              </div>
              <p className="text-sm text-gray-900 mb-3">{application.appliedProperty}</p>
              <div className="flex flex-wrap gap-2">
                <button className="text-sm text-blue-600 hover:text-blue-900">
                  {t('viewDetails')}
                </button>
                {application.status === 'reviewing' && (
                  <>
                    <button className="text-sm text-green-600 hover:text-green-900">
                      {t('approve')}
                    </button>
                    <button className="text-sm text-red-600 hover:text-red-900">
                      {t('reject')}
                    </button>
                  </>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TenantScreeningView;
